import type { OsobyFyzickaOsobaDto } from '@gov-nx/api';

export const isAdult = (age: OsobyFyzickaOsobaDto['vek']) =>
	age ? age >= 18 : false;
